<!--
* @Name：采购订单审批基本页面
* @Author: 刘玉
* @Date: 2021-12-09 10:39:49
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-09 10:39:49
-->
<template>
  <div>
    <hi-cell title="申请单号：" :value="headInfo.applyCode"></hi-cell>
    <hi-cell title="公司：" :value="headInfo.corpFullName"></hi-cell>
    <hi-cell title="订单类型：" :value="headInfo.poTypeDict" :options="poTypeOptions"></hi-cell>
    <hi-cell title="供应商：" :value="headInfo.suppName"></hi-cell>
    <hi-cell title="币种：" :value="headInfo.currencyDict" :options="currencyDictOptions"></hi-cell>
    <hi-cell title="付款条件：" :value="headInfo.payCondDict" :options="payTermOptions"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="申请时间：" :value="headInfo.crtTime"></hi-cell>
    <hi-cell title="订单摘要：" :value="headInfo.remark"></hi-cell>
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {},
  data() {
    return {}
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    poTypeOptions() {
      return this.$store.getters.dicts.po_type
    },
    currencyDictOptions() {
      return this.$store.getters.dicts.currency_dict
    },
    payTermOptions() {
      return this.$store.getters.dicts.pay_term
    }
  }
}
</script>
